<template>
    <div>
        <div class='d-flex justify-content-between neue' :class="{ 'mb32': this.isMobile, 'mb16': !this.isMobile }">
            <Icon v-if="this.isMobile" name="arrow-left" class="c24 pointer" @click="this.close()"/>
            <h4 class="fsp20 lh28 text-black neue mb-0" :class="{ 'mr24 text-center flex-grow-1': this.isMobile }">{{ this.$store.state.modal.content.title }}</h4>
            <Icon v-if="!this.isMobile" name="close" class="c24 pointer" @click="this.close()"/>
        </div>
        <div class="bg-white rounded12" :class="{ 'p24': !this.isMobile }">
            <div v-for="(item, index) in this.columns" :key="index" class="d-flex mb16 lh28">
                <Checkbox 
                    :id='"check_column_" + this.columnsChoised[index].id' 
                    :dataValue="this.columnsChoised[index].value" 
                    @updateParentState="this.updateState"
                    :label="this.columnsChoised[index].text_name ? this.columnsChoised[index].text_name : this.columnsChoised[index].name"
                    :disabled="this.isItemDisabled(this.columnsChoised[index].key_name)"
                />
            </div>
            <div class="d-flex" :class="{ 'position-fixed bottom-0 left-0 end-0 py16 px24 w-100 border-t bg-white': this.isMobile, 'mt40': !this.isMobile }">
                <Button
                    :name="this.$t('views.ATM.12')"
                    type='btn-warning'
                    @click="this.setColumns()"
                    class="h40 equal-width mr16"
                    :class="{ 'h48': this.isMobile }"
                />
                <Button
                    :name="this.$t('views.ChoiseColumns.2')"
                    type='btn-outline-grey'
                    @click="this.reset()"
                    class="h40 equal-width primary-grey"
                    :class="{ 'h48': this.isMobile }"
                />
            </div>
        </div>
    </div>
</template>

<script>
import Button from '@/components/service/Button';
import Checkbox from '@/components/service/Checkbox';
import Icon from '@/components/icons/Icon.vue';

export default {
    components: {
        Button,
        Checkbox,
        Icon
    },
    props: {
        close: [Function],
    },
    data() {
        return {
            columns: [],
            columnsChoised: [],
            disabledColumns: this.$store.state.modal.content.disabledColumns,
            initialColumns: this.$store.state.modal.content.initialColumns,
        }
    },
    computed: {
        isMobile() {
            return this.$store.state.resize.w <= 768;
        }
    },
    methods: {
        getColumnNumber(input) {
            const regex = /check_column_(\d+)/;
            const match = input.match(regex);

            if (match) {
                return match[1];
            } else {
                return null;
            }
        },
        updateState(arg) {
            const id = this.getColumnNumber(arg.id);
            const column = this.columnsChoised.find(item => item.id == id);
            column.value = arg.value;
        },
        reset() {
            this.$store.state.modal.content.reset();
            this.columns = [];
            this.columns = [...this.initialColumns];
            this.columnsChoised = JSON.parse(JSON.stringify(this.columns));
        },
        setColumns() {
            this.$store.state.modal.content.updateColumns(this.columnsChoised);
            this.close();
        },
        isItemDisabled(key_name) {
            return this.disabledColumns.includes(key_name);
        }
    },
    created() {
        this.columns = this.$store.state.modal.content.columns;
        this.columnsChoised = JSON.parse(JSON.stringify(this.columns));
    }
}
</script>

<style lang="scss" scoped>

</style>